import Vue from 'vue';
import Router from 'vue-router';
import errorPage from './views/errorPage'; //错误页面
const childrenRouter = () =>
    import ('./components/common/routerCom.vue'); // 公共路由

Vue.use(Router)
let routes = [{
        path: "/",
        redirect: "/home",
        meta: {
            isShow: false,
        },
    },
    {
        path: '/errorPage',
        name: 'errorPage',
        component: errorPage,
        meta: {
            isShow: false,
            title: "404",
            showMenuItem: 'errorPage'
        }
    },
    //首页
    {
        path: '/home',
        name: '/home',
        component: require("@/views/Home").default,
        meta: {
            isShow: true,
            title: "首页",
            titleEn: "Home",
            showMenuItem: 'home'
        }
    },
    // 客房与套房查找结果
    {
        path: '/room',
        name: '/room',
        component: require("@/views/room").default,
        meta: {
            isShow: false,
            title: "查找结果",
            titleEn: "room",
            showMenuItem: 'room'
        }
    },
    //品牌了解
    // {
    //     path: '/Brand',
    //     name: '/Brand',
    //     component: require("@/views/Brand").default,
    //     meta: {
    //         isShow: true,
    //         title: "品牌了解",
    //         titleEn: "Brand",
    //         showMenuItem: 'Brand'
    //     }
    // },
    //会议与宴会
    {
        path: '/conferencesAndBanquets',
        name: '/conferencesAndBanquets',
        component: require("@/views/conferencesAndBanquets").default,
        meta: {
            isShow: true,
            title: "会议与宴会",
            titleEn: "Meeting",
            showMenuItem: 'conferencesAndBanquets'
        }
    },
    //运动与美学
    {
        path: '/Beauty',
        name: '/Beauty',
        component: require("@/views/Beauty").default,
        meta: {
            isShow: true,
            title: "运动与美学",
            titleEn: "Beauty",
            showMenuItem: 'Beauty'
        }
    },
    //酒店动态


    // {
    //   path: '/hotelDynamic',
    //   component: childrenRouter,
    //   meta: {
    //     isShow: true,
    //     title: "酒店动态",
    //     showMenuItem:'hotelDynamic'
    //   },
    //   children:[
    //     {
    //       path: "/",
    //       redirect: "hotelDynamicList",
    //       meta: {
    //         isShow: false,
    //       },
    //     },
    //     {
    //       path: '/hotelDynamic/hotelDynamicList',
    //       name: 'hotelDynamicList',
    //       component: require("@/components/hotelDynamic/hotelDynamicList").default,
    //       meta: {
    //         isShow: true,
    //         title: "酒店动态列表",
    //         showMenuItem:'hotelDynamicList'
    //       },
    //     },
    //     {
    //       path: '/hotelDynamic/artical',
    //       name: 'artical',
    //       component: require("@/components/hotelDynamic/artical").default,
    //       meta: {
    //         isShow: false,
    //         title: "酒店动态详情",
    //         showMenuItem:'artical'
    //       },
    //     }
    //   ]
    // }
    {
        path: '/hotelDynamic',
        name: '/hotelDynamic',
        component: require("@/views/hotelDynamic").default,
        meta: {
            isShow: true,
            title: "酒店动态",
            titleEn: "Hotel dynamic",
            showMenuItem: 'hotelDynamic'
        }
    },
    {
        path: '/hotelDynamic/artical',
        name: '/artical',
        component: require("@/components/hotelDynamic/artical").default,
        meta: {
            isShow: false,
            title: "酒店动态详情",
            titleEn: "Hotel dynamic artical",
            showMenuItem: 'hotelDynamicArtical'
        }
    },
    {
        path: "*",
        redirect: "/home",
        meta: {
            isShow: false,
        },
    },


];
const router = new Router({
    mode: 'history', //去掉url中的#
    // base: process.env.NODE_ENV == 'development' ? '/' : '/lvshou-hotel-pc/',
    base:"/",
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes
})

export default router;
export {
    routes
};

// export default new Router({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   routes: [
//     {
//       path: '/',
//       name: 'home',
//       component: Home
//     },
//     {
//       path: '/about',
//       name: 'about',
//       // route level code-splitting
//       // this generates a separate chunk (about.[hash].js) for this route
//       // which is lazy-loaded when the route is visited.
//       component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
//     }
//   ]
// })